import { type IBaseWorkflowData, type IWorkFlowContactEventStep } from 'entities/Workflow'
import type { IParamsFiltersList } from 'entities/Broadcast/api/types'
import type { IResponseFilterSegment } from 'entities/Segment'

function isIResponseFilterSegment(
  item: IParamsFiltersList | IResponseFilterSegment[]
): item is IResponseFilterSegment[] {
  return Array.isArray(item)
}

export const transformWorkflowV1TriggerArgsToV2 = (
  args: IBaseWorkflowData['definition']['trigger']['args']
): IWorkFlowContactEventStep['args'] | undefined => {
  const filters = args?.filters
  if (!filters) return undefined

  if (isIResponseFilterSegment(filters)) {
    return {
      filters: {
        contacts: [],
        tags: [],
        segments: [],
        advanced: [
          {
            filtersList: filters,
          },
        ],
      },
    }
  } else {
    return { filters }
  }
}
